<template>
    <div style="background-color: white">
        <!--导航栏 start-->
        <van-nav-bar
                title="数据分析"
                left-text="返回"
                @click-left="onClickLeft"
                left-arrow
                fixed
        />
        <!--导航栏 end-->
        <div style="margin-top: 1.3rem">
            <div class="tb_title">
                <div class="tb_title_dot"></div>
                30天新进商户分析
            </div>
            <line-charts :chart-data="lineChartDatas"/>
            <div class="tb_title">
                <div class="tb_title_dot"></div>
                商户活跃度分析
            </div>
            <pie-chart  />
        </div>

    </div>


</template>

<script>
    import LineCharts from './LineChartss'
    import PieChart from './Business'
    const lineChartDatas = {
        newVisitis: {
            expectedData: [100, 120, 161, 134, 105, 160, 165],
            actualData: [120, 82, 91, 154, 162, 140, 145]
        },
        messages: {
            expectedData: [200, 192, 120, 144, 160, 130, 140],
            actualData: [180, 160, 151, 106, 145, 150, 130]
        },
        purchases: {
            expectedData: [80, 100, 121, 104, 105, 90, 100],
            actualData: [120, 90, 100, 138, 142, 130, 130]
        },
        shoppings: {
            expectedData: [130, 140, 141, 142, 145, 150, 160],
            actualData: [120, 82, 91, 154, 162, 140, 130]
        }
    }
    export default {
        components:{
            LineCharts,
            PieChart
        },
        name: "AgentAnalysis",
        data(){
            return{
                lineChartDatas: lineChartDatas.newVisitis
            }
        },
        methods:{
            onClickLeft(){
              this.$router.go(-1)
            },
            // handleSetLineChartData(type) {
            //     this.lineChartDatas = lineChartDatas[type]
            // }
        },
        // 组件内路由--进入组件时
        beforeRouteEnter(to, from, next) {
            window.document.body.style.backgroundColor = '#f5f5f5';
            next();
        },
        // 组件内路由--离开组件时
        beforeRouteLeave(to, from, next) {
            window.document.body.style.backgroundColor = '';
            next();
        },
    }
</script>

<style scoped>
    .tb_title {
        color: #756e6e;
        font-size: 16px;
    }
    .tb_title_dot {
        background: #20a0ff;
        width: 5px;
        height: 12px;
        display: inline-block;
    }
</style>
